var map = {
	"./Minicard_2c.svg": 156,
	"./Minicard_2d.svg": 157,
	"./Minicard_2h.svg": 158,
	"./Minicard_2s.svg": 159,
	"./Minicard_3c.svg": 160,
	"./Minicard_3d.svg": 161,
	"./Minicard_3h.svg": 162,
	"./Minicard_3s.svg": 163,
	"./Minicard_4c.svg": 164,
	"./Minicard_4d.svg": 165,
	"./Minicard_4h.svg": 166,
	"./Minicard_4s.svg": 167,
	"./Minicard_5c.svg": 168,
	"./Minicard_5d.svg": 169,
	"./Minicard_5h.svg": 170,
	"./Minicard_5s.svg": 171,
	"./Minicard_6c.svg": 172,
	"./Minicard_6d.svg": 173,
	"./Minicard_6h.svg": 174,
	"./Minicard_6s.svg": 175,
	"./Minicard_7c.svg": 176,
	"./Minicard_7d.svg": 177,
	"./Minicard_7h.svg": 178,
	"./Minicard_7s.svg": 179,
	"./Minicard_8c.svg": 180,
	"./Minicard_8d.svg": 181,
	"./Minicard_8h.svg": 182,
	"./Minicard_8s.svg": 183,
	"./Minicard_9c.svg": 184,
	"./Minicard_9d.svg": 185,
	"./Minicard_9h.svg": 186,
	"./Minicard_9s.svg": 187,
	"./Minicard_Ac.svg": 188,
	"./Minicard_Ad.svg": 189,
	"./Minicard_Ah.svg": 190,
	"./Minicard_As.svg": 191,
	"./Minicard_Jc.svg": 192,
	"./Minicard_Jd.svg": 193,
	"./Minicard_Jh.svg": 194,
	"./Minicard_Js.svg": 195,
	"./Minicard_Kc.svg": 196,
	"./Minicard_Kd.svg": 197,
	"./Minicard_Kh.svg": 198,
	"./Minicard_Ks.svg": 199,
	"./Minicard_Qc.svg": 200,
	"./Minicard_Qd.svg": 201,
	"./Minicard_Qh.svg": 202,
	"./Minicard_Qs.svg": 203,
	"./Minicard_Tc.svg": 204,
	"./Minicard_Td.svg": 205,
	"./Minicard_Th.svg": 206,
	"./Minicard_Ts.svg": 207,
	"./Minicard_back.svg": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;